import api from './api';

export const coursesService = {
  // Récupérer tous les cours
  getAllCourses: async (filters = {}) => {
    try {
      const response = await api.get('/courses', {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  },

  // Récupérer un cours par ID
  getCourseById: async (id) => {
    try {
      const response = await api.get(`/courses/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching course ${id}:`, error);
      throw error;
    }
  },

  // Récupérer un cours par slug
  getCourseBySlug: async (slug) => {
    try {
      const response = await api.get(`/courses/by-slug/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching course with slug ${slug}:`, error);
      throw error;
    }
  },

  // Récupérer les cours par catégorie
  getCoursesByCategory: async (categoryId, filters = {}) => {
    try {
      const response = await api.get(`/courses/by-category/${categoryId}`, {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching courses for category ${categoryId}:`, error);
      throw error;
    }
  },

  // Récupérer les cours par auteur
  getCoursesByAuthor: async (authorId, filters = {}) => {
    try {
      const response = await api.get(`/courses/by-author/${authorId}`, {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching courses for author ${authorId}:`, error);
      throw error;
    }
  },

  // Récupérer un cours complet avec modules et leçons
  getCourseFull: async (id) => {
    try {
      const response = await api.get(`/courses/${id}/full`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching full course ${id}:`, error);
      throw error;
    }
  },

  // Créer un nouveau cours
  createCourse: async (courseData) => {
    try {
      const response = await api.post('/courses', courseData);
      return response.data;
    } catch (error) {
      console.error('Error creating course:', error);
      throw error;
    }
  },

  // Mettre à jour un cours
  updateCourse: async (id, courseData) => {
    try {
      const response = await api.put(`/courses/${id}`, courseData);
      return response.data;
    } catch (error) {
      console.error(`Error updating course ${id}:`, error);
      throw error;
    }
  },

  // Supprimer un cours
  deleteCourse: async (id) => {
    try {
      const response = await api.delete(`/courses/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course ${id}:`, error);
      throw error;
    }
  }
};

export default coursesService;